module.exports = __webpack_public_path__ + "static/media/logo.9dc080de.svg";